import DiscountModel from "../models/DiscountModel";
import { DiscountTypes } from "../common/enums";
import axios from "axios";

export default class apiDiscount {

    static async getAll(): Promise<Array<DiscountModel>> {        
        let models = new Array<DiscountModel>();        

        let respone = await axios.post("api/Discount/getAll");
        respone.data.models.forEach((item: any) =>
            models.push(DiscountModel.from(item))
        );        

        return models;
    }

    static async create(): Promise<DiscountModel> {        
        let respone = await axios.post("api/Discount/create");
        let model = DiscountModel.from(respone.data.model)            

        return model;
    }

    static async save(discount: DiscountModel): Promise<void> {          
        let respone = await axios.post("api/Discount/save", {
            model: discount,
        });
    }

    static async delete(discountId: number): Promise<void> {            
        let respone = await axios.post("api/Discount/delete", {
            ModelId: discountId,
        });
    }
}
